// extracted by mini-css-extract-plugin
export default {"modal-header":"styles_modal-header__X6Yb2","container":"styles_container__MvE+w","divider":"styles_divider__s6G6Q"};